import { FontAwesome } from '@expo/vector-icons'
import { createStackNavigator } from '@react-navigation/stack'
import _ from 'lodash'
import React from 'react'
import { TouchableOpacity } from 'react-native'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'

import Button from '../../components/Button'
import { useAstrolabe, AstrolabeScreen, TAList, TAModal } from '../astrolabe'
import { useLocalPreference } from '../global'

const MainStack = createStackNavigator()
const RootStack = createStackNavigator()

function MainStackScreen({ navigation }) {
  const { t } = useTranslation()
  const { setDraftTA } = useAstrolabe()

  return (
    <MainStack.Navigator>
      <MainStack.Screen
        name="talist"
        component={TAList}
        options={{
          title: t('astrolabe.ta_list'),
          headerRight: () => (
            <TouchableOpacity
              style={{ paddingVertical: 12, paddingHorizontal: 16 }}
              onPress={() => {
                setDraftTA()
                navigation.navigate('modal')
              }}>
              <FontAwesome name="plus" size={20} />
            </TouchableOpacity>
          ),
        }}
      />
      <MainStack.Screen
        name="astrolabe"
        component={AstrolabeScreen}
        options={{ title: t('astrolabe.astrolabe') }}
      />
    </MainStack.Navigator>
  )
}

function RootStackScreen({ navigation, isWideScreen }) {
  const { t } = useTranslation()
  const { theme } = useLocalPreference()
  const { taList, setTAList, draftTA } = useAstrolabe()

  console.log('RootStackScreen', isWideScreen)

  return (
    <RootStack.Navigator mode="modal">
      <RootStack.Screen
        name="talist"
        component={MainStackScreen}
        options={{ headerShown: false, title: t('astrolabe.ta_list') }}
      />
      <RootStack.Screen
        name="modal"
        options={{
          title: draftTA && draftTA.id ? t('edit') : t('add'),
          // eslint-disable-next-line react/display-name
          headerRight: () => (
            <Button
              theme={theme}
              onPress={() => {
                // Modify
                if (draftTA.id) {
                  const idx = _.findIndex(taList, { id: draftTA.id })
                  setTAList([
                    ..._.slice(taList, 0, idx),
                    draftTA,
                    ..._.slice(taList, idx + 1, taList.length),
                  ])
                } else {
                  // Create new
                  setTAList([
                    ...taList,
                    {
                      ...draftTA,
                      id: uuidv4(),
                    },
                  ])
                }
                navigation.goBack()
              }}
              label={t('save')}
              width="auto"
              borderWidth={0}
            />
          ),
        }}
      >
        {screenProps => <TAModal {...screenProps} isWideScreen={isWideScreen} />}
      </RootStack.Screen>
    </RootStack.Navigator>
  )
}

export default RootStackScreen
